import React from "react";
import "./sectionSix.css";
import sectionSixImg from "../../assets/sectionSixImg.png";
import Section6Element from "../section6Element/section6Element";

const SectionSix = () => {
  return (
    <div className="sectionSix-main-wrapper" style={{marginTop: '-5px'}}>
      <div className="sectionSix-inner-container">
        <div>
          <div className="sectionSix-roadmap-heading">
            <h1>BIG PICTURE ROADMAP</h1>
          </div>
          <div className="sectionSix-Element-wrapper">
            <div className="sectinonSix-content">
              <Section6Element />
              <Section6Element />
              <Section6Element />
              <Section6Element />
              <button className="viewMore-btn">VIEW MORE</button>
              <Section6Element />
            </div>
            <div className="sectionSix-imageSection">
              <div>
                <Section6Element />
              </div>
              <div className="sectionSix-image-text">
                <p>
                  More surprises as we go along! Can’t just give everything away
                  ;)
                </p>
              </div>
              <img src={sectionSixImg} alt="sectionSixImg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionSix;
